package com.ai.mitra.presentation.screens.detailscreen

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.ai.mitra.di.AdMobBanner
import com.ai.mitra.presentation.components.DeleteChatAlertDialogBox
import com.ai.mitra.presentation.components.WelcomeScreen
import com.ai.mitra.presentation.screens.chatscreen.ChatScreen
import com.ai.mitra.presentation.screens.chatscreen.ChatViewModel
import com.ai.mitra.presentation.screens.mainscreen.MainViewModel
import com.ai.mitra.theme.lightBackgroundColor


@Composable
fun DetailScreen(mainViewModel: MainViewModel, chatViewModel: ChatViewModel) {

    val chatUiState by chatViewModel.chatUiState.collectAsState()
    val groupUiState by mainViewModel.uiState.collectAsState()
    DeleteChatAlertDialogBox(chatViewModel, mainViewModel)
    Column(
        Modifier.fillMaxHeight().background(lightBackgroundColor),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        if (groupUiState.data.isNotEmpty() && mainViewModel.currentPos != -1) {
            ChatScreen(
                mainViewModel,
                chatViewModel,
                chatUiState,
                groupUiState,
                groupUiState.data[mainViewModel.currentPos]
            )
        } else {
            WelcomeScreen()
        }
    }
}